import { render, staticRenderFns } from "./GameBrand.vue?vue&type=template&id=bd1dda74"
import script from "./GameBrand.vue?vue&type=script&lang=js"
export * from "./GameBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports